import React from 'react';
import {
    createHashRouter,
    RouterProvider,
} from "react-router-dom";

import Routes from '../../../constants/Routes';

const router = createHashRouter(Routes);

interface IAppRouterProps {
}

function AppRouter(props: IAppRouterProps) {
    return (
        <RouterProvider router={router} />
    );
}

export default AppRouter;
